import React from "react";
import { motion } from "framer-motion";
import { Zap, Lock } from "lucide-react";

const PremiumLeadGate = ({ onClick }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="absolute inset-0 bg-white/80 backdrop-blur-[2px] flex flex-col items-center justify-center z-10 p-6 rounded-lg"
    >
      <div className="p-3 bg-purple-100 rounded-full mb-3">
        <Lock className="w-6 h-6 text-purple-500" />
      </div>
      <h3 className="text-lg font-semibold text-gray-800 mb-2 text-center">Premium Lead</h3>
      <p className="text-sm text-gray-600 mb-4 text-center max-w-xs">Unlock all high-quality leads with a premium subscription</p>
      <button
        onClick={onClick}
        className="px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg font-medium flex items-center shadow-md hover:shadow-lg transition-all"
      >
        <Zap className="w-4 h-4 mr-2" />
        Upgrade Now
      </button>
    </motion.div>
  );
};

export default PremiumLeadGate;
